/**
 * About Page Template
 *
 * Renders the About page from Prismic Slice Zone.
 * Reuses Hero, Partners, About, Contact; adds SwiperSlider, Global, Careers.
 */

import React from "react";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { SliceZone } from "@prismicio/react";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { components } from "../slices";

const AboutTemplate = ({ data, pageContext }) => {
  if (!data) return null;

  const aboutPage = data.prismicAboutPage || {};
  const topMenu = data.prismicTopMenu?.data || {};
  const footerData = data.prismicFooter?.data || {};

  return (
    <Layout topMenu={topMenu} footerData={footerData} slug={pageContext.slug}>
      <SliceZone slices={aboutPage.data?.body || []} components={components} />
    </Layout>
  );
};

export const query = graphql`
  query AboutPageQuery($id: String!) {
    prismicAboutPage(id: { eq: $id }) {
      _previewable
      data {
        meta_title
        meta_description
        meta_image {
          url
        }
        body {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...AboutPageDataBodyHero
          ...AboutPageDataBodyPartners
          ...AboutPageDataBodyAbout
          ...AboutPageDataBodySwiperSlider
          ...AboutPageDataBodyGlobal
          ...AboutPageDataBodyCareers
          ...AboutPageDataBodyContact
          ...AboutPageDataBodyTextBlock
          ...AboutPageDataBodyTestimonials
        }
      }
    }
    prismicTopMenu {
      ...TopMenuFragment
    }
    prismicFooter {
      ...FooterFragment
    }
  }
`;

/**
 * Per-page SEO default. Used when the Prismic editor leaves the
 * description field blank — Prismic still overrides when set.
 */
const ABOUT_DEFAULT_DESCRIPTION =
  "Meet Low Battery — the media company building the next generation of fandom across music, gaming, and culture. Learn about our brands, partners, and global reach.";

export const Head = ({ data, location }) => {
  const aboutPage = data?.prismicAboutPage?.data || {};

  return (
    <Seo
      title={aboutPage.meta_title || "About"}
      description={aboutPage.meta_description || ABOUT_DEFAULT_DESCRIPTION}
      image={aboutPage.meta_image?.url}
      pathname={location?.pathname}
    />
  );
};

export default withPrismicPreview(AboutTemplate);
